import React, { useState, createContext, useContext } from 'react';
interface TimerContextType {
  interval: number;
  updateInterval: (seconds: number) => void;
}
const TimerContext = createContext<TimerContextType | undefined>(undefined);
export function TimerProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [interval, setInterval] = useState(30 * 60); // Default: 30 minutes
  const updateInterval = (seconds: number) => {
    setInterval(seconds);
  };
  return <TimerContext.Provider value={{
    interval,
    updateInterval
  }} data-id="element-1293">
      {children}
    </TimerContext.Provider>;
}
export function useTimerSettings() {
  const context = useContext(TimerContext);
  if (context === undefined) {
    throw new Error('useTimerSettings must be used within a TimerProvider');
  }
  return context;
}